import { IFeedbackTrialClassDataObject } from "components/kelas-live/hooks/use-user-landing/use-user-landing.types";
import { ModalSize } from "components/modal/modal.types";

import { NpsInitialStateType } from "../nps-reducer.types";

export interface IUseNpsModal {
  handleModalClose: () => void;
  handleNpsFeedbackSkip: () => void;
  state: NpsInitialStateType;
  submitParentNumberForm: (phoneNumber: string) => void;
  submitNpsFeedback: (scale: string) => void;
  submitFeedbackExplanationForm: (comment: string) => void;
  toggleSkipConfirmation: (
    from:
      | ToggleSkipConfirmationTypes.PARENT_PHONE_NUMBER_SCREEN
      | ToggleSkipConfirmationTypes.SKIP_CONFIRMATION_SCREEN,
    phoneNumber?: string
  ) => void;
  closeNpsFeedback: (scale?: string) => void;
  trackScaleChange: (scaleValue: string) => void;
  closeFeedbackExplanationForm: (comment?: string) => void;
  closeSkipConfirmation: () => void;
  closeModalAfterSuccess: () => void;
  getCurrentModalPhase: (
    state: NpsInitialStateType
  ) => NPSModalPhases | undefined;
  getCurrentModalSize: (
    state: NpsInitialStateType
  ) => ModalSize.Narrow | ModalSize.Wide;
  checkParentNumberIsAlreadySubmitted: () => void;
}

export interface IUseNpsModalProps {
  onClose: () => void;
  feedbackTrialClassDataObject: IFeedbackTrialClassDataObject;
}

export enum ToggleSkipConfirmationTypes {
  PARENT_PHONE_NUMBER_SCREEN = "parentPhoneNumberScreen",
  SKIP_CONFIRMATION_SCREEN = "skipConfirmation"
}

export enum NPSModalPhases {
  RATING_PHASE = "ratingPhase",
  PARENT_NUMBER_INPUT_PHASE = "parentNumberPhase",
  FEEDBACK_PHASE = "feedbackPhase",
  SKIP_CONFIRMATION_PHASE = "skipConfirmationPhase",
  THANKYOU_AFTER_PARENT_FORM = "thankyouAfterParentForm",
  THANKYOU_AFTER_FEEDBACK_FORM = "thankyouAfterFeedbackForm"
}
